export default __webpack_public_path__ + "static/media/icon9.a3cbc658.svg";